import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardNavigationService {
  private backButtonClickSubject = new Subject<void>();
  public backButtonClick$ = this.backButtonClickSubject.asObservable();

  private isChartFormOpenSubject = new Subject<boolean>();
  public isChartFormOpen$ = this.isChartFormOpenSubject.asObservable();

  private isEditModeSubject = new Subject<boolean>();
  public isEditMode$ = this.isEditModeSubject.asObservable();

  private _isChartFormOpen = false;
  private _isEditMode = false;

  emitBackButtonClick() {
    this.backButtonClickSubject.next();
  }

  setChartFormOpen(isOpen: boolean) {
    this._isChartFormOpen = isOpen;
    this.isChartFormOpenSubject.next(isOpen);
  }

  get isChartFormOpen(): boolean {
    return this._isChartFormOpen;
  }

  setEditMode(isEditMode: boolean) {
    this._isEditMode = isEditMode;
    this.isEditModeSubject.next(isEditMode);
  }

  get isEditMode(): boolean {
    return this._isEditMode;
  }
}

